import { AppText } from "@toothfairy/shared-ui";
import AppActivityIndicator from "@toothfairy/shared-ui/AppActivityIndicator";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";
import { View } from "react-native";
// import LottieView from "lottie-react-native";
import Lottie from "react-lottie";
import animationData from "./animation.json";
const LoadingPlaceholder = ({
  caption = "",
  style,
  brandedAnimation = true,
  fontColor,
  textStyle,
  ...props
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <View style={[{ flex: 1 }, style]}>
      <View style={{ margin: "auto" }}>
        {brandedAnimation ? (
          <Lottie options={defaultOptions} height={36} width={38} />
        ) : (
          <AppActivityIndicator {...props} />
        )}
        <AppText
          style={[{ fontSize: currentTheme?.theme?.base_font_size }, textStyle]}
          fontWeight="bold"
          color={fontColor}
          wrapperStyle={{ marginTop: 20 }}
        >
          {caption}
        </AppText>
      </View>
    </View>
  );
};

export default LoadingPlaceholder;
